module.exports = __webpack_public_path__ + "img/businessImg13.99bf4855.png";